// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   WhyForgeExists — Section 03
   Two-column: left content + right full-bleed photo
   ============================================================ */

.wfe {
  background: var(--c-cream);
  padding-top: var(--section-y);
  padding-bottom: 0;
  overflow: hidden;
  position: relative;
}

/* ── Two-column layout ──────────────────────────────────────── */
.wfe__layout {
  display: grid;
  /* left content | thin rail | right photo */
  grid-template-columns: 3rem 1fr 1fr;
  grid-template-areas: "rail left right";
  align-items: stretch;
  min-height: 70vh;

  margin-inline: auto;
  padding-inline: var(--gutter);
  gap: clamp(1.5rem, 3vw, 3rem);
}

/* ── Left column ────────────────────────────────────────────── */
.wfe__left {
  grid-area: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: clamp(1.25rem, 2.5vw, 2rem);
  padding-block: clamp(1rem, 3vw, 2.5rem);
}

/* Section label */
.wfe__label {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.wfe__num {
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  color: var(--text-muted);
  flex-shrink: 0;
}

.wfe__rule {
  display: block;
  width: 1px;
  height: 1.1rem;
  background: var(--line);
  flex-shrink: 0;
}

/* ── Two-tone headline ──────────────────────────────────────── */
.wfe__headline {
  display: flex;
  flex-direction: column;
  gap: 0.15em;
  margin: 0;
}

/* First block — dark forest/ink */
.wfe__hl-ink {
  font-size: clamp(2rem, 4vw, 3.4rem);
  color: var(--c-forest);
  line-height: 0.99;
}

/* Second block — rust accent */
.wfe__hl-rust {
  font-size: clamp(2rem, 4vw, 3.4rem);
  color: var(--accent);
  line-height: 0.99;
}

/* ── Body paragraphs ────────────────────────────────────────── */
.wfe__body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 36rem;
}

.wfe__body p {
  font-family: var(--font-body);
  font-size: clamp(0.88rem, 1.1vw, 1rem);
  color: var(--c-ink);
  line-height: 1.68;
}

/* ── Signature row ──────────────────────────────────────────── */
.wfe__sig-row {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 2.5vw, 2rem);
  margin-top: 0.5rem;
}

/* Script signature — Playfair italic simulates handwriting */
.wfe__sig-script {
  font-family: var(--font-serif);
  font-style: italic;
  font-size: clamp(1.8rem, 3vw, 2.6rem);
  color: var(--c-ink);
  line-height: 1;
  display: block;
  margin-bottom: 0.4rem;
  letter-spacing: -0.01em;
}

.wfe__sig-name {
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--c-ink);
  display: block;
}

/* ── Circular badge (shared pattern) ───────────────────────── */
.wfe__badge {
  position: relative;
  width: clamp(80px, 9vw, 120px);
  height: clamp(80px, 9vw, 120px);
  flex-shrink: 0;
}

.wfe__badge-ring {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.wfe__badge-circle {
  fill: none;
  stroke: var(--accent);
  stroke-width: 1;
  opacity: 0.55;
}

.wfe__badge-text {
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.18em;
  fill: var(--accent);
  text-transform: uppercase;
}

.wfe__badge-tick {
  stroke: var(--accent);
  stroke-width: 1.5;
  opacity: 0.7;
}

.wfe__badge-logo {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wfe__badge-logo img {
  width: 36%;
  height: auto;
  object-fit: contain;
}

/* ── Icon rail ──────────────────────────────────────────────── */
.wfe__rail {
  grid-area: rail;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-block: clamp(2rem, 4vw, 4rem);
  gap: 0;
}

.wfe__rail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1rem;
  color: var(--c-ink);
  opacity: 0.75;
}

/* Connector segment between icons */
.wfe__rail-seg {
  display: block;
  width: 1px;
  height: clamp(1.5rem, 3.5vw, 3rem);
  background: rgba(27, 27, 27, 0.28);
  margin-block: 0.5rem;
}

/* ── Right column — photo ───────────────────────────────────── */
.wfe__right {
  grid-area: right;
  position: relative;
  margin-right: calc(-1 * var(--gutter));
}

/* Clip container so the parallax translateY stays inside bounds */
.wfe__photo-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.wfe__photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
  /* Slight desaturate to match the dramatic B&W look in design */
  filter: grayscale(30%) contrast(1.08);
}

/* ── Coordinate stamp ───────────────────────────────────────── */
.wfe__stamp-wrap {
  position: absolute;
  bottom: clamp(1.5rem, 4vw, 3rem);
  right: clamp(1rem, 3vw, 2.5rem);
  z-index: 2;
}

.wfe__stamp {
  background: #e8d9b8;
  border: 2px solid rgba(168, 102, 66, 0.35);
  padding: 0.9rem;
  width: clamp(200px, 22vw, 300px);
  /* Aged / slightly rotated feel */
  transform: rotate(10deg);
  box-shadow:
    0 4px 18px rgba(27, 27, 27, 0.22),
    inset 0 0 0 1px rgba(168, 102, 66, 0.12);
  position: relative;
  /* Perforated right edge — dots via repeating gradient */
  border-right: none;

  clip-path: polygon(
    4% 0%,
    8% 2%,
    12% 0%,
    16% 2%,
    20% 0%,
    24% 2%,
    28% 0%,
    32% 2%,
    36% 0%,
    40% 2%,
    44% 0%,
    48% 2%,
    52% 0%,
    56% 2%,
    60% 0%,
    64% 2%,
    68% 0%,
    72% 2%,
    76% 0%,
    80% 2%,
    84% 0%,
    88% 2%,
    92% 0%,
    96% 2%,
    100% 4%,

    98% 8%,
    100% 12%,
    98% 16%,
    100% 20%,
    98% 24%,
    100% 28%,
    98% 32%,
    100% 36%,
    98% 40%,
    100% 44%,
    98% 48%,
    100% 52%,
    98% 56%,
    100% 60%,
    98% 64%,
    100% 68%,
    98% 72%,
    100% 76%,
    98% 80%,
    100% 84%,
    98% 88%,
    100% 92%,
    98% 96%,
    96% 100%,

    92% 98%,
    88% 100%,
    84% 98%,
    80% 100%,
    76% 98%,
    72% 100%,
    68% 98%,
    64% 100%,
    60% 98%,
    56% 100%,
    52% 98%,
    48% 100%,
    44% 98%,
    40% 100%,
    36% 98%,
    32% 100%,
    28% 98%,
    24% 100%,
    20% 98%,
    16% 100%,
    12% 98%,
    8% 100%,
    4% 98%,
    0% 96%,

    2% 92%,
    0% 88%,
    2% 84%,
    0% 80%,
    2% 76%,
    0% 72%,
    2% 68%,
    0% 64%,
    2% 60%,
    0% 56%,
    2% 52%,
    0% 48%,
    2% 44%,
    0% 40%,
    2% 36%,
    0% 32%,
    2% 28%,
    0% 24%,
    2% 20%,
    0% 16%,
    2% 12%,
    0% 8%,
    2% 4%
  );

  box-shadow:
    0 4px 18px rgba(27, 27, 27, 0.22),
    inset 0 0 0 1px rgba(168, 102, 66, 0.12);
}

.stamp_inner {
  border: 2px solid var(--c-ink);
  padding: 0.8rem;
}

/* Perforated edge simulation */
.wfe__stamp::after {
  content: "";
  position: absolute;
  top: 0;
  right: -1px;
  bottom: 0;
  width: 1px;
  background: repeating-linear-gradient(to bottom, transparent, transparent 6px, #e8d9b8 6px, #e8d9b8 10px);
}

.wfe__stamp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.55rem;
}

.wfe__stamp-name {
  font-family: var(--font-display);
  font-size: clamp(1.4rem, 2.5vw, 2rem);
  color: var(--c-ink);
  letter-spacing: 0.06em;
  line-height: 1;
}

.wfe__stamp-logo {
  width: clamp(18px, 2vw, 26px);
  height: auto;
  opacity: 0.85;
}

.wfe__stamp-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0.15rem;
}

.wfe__stamp-label {
  font-family: var(--font-body);
  font-size: 0.58rem;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.wfe__stamp-value {
  font-family: var(--font-body);
  font-size: 0.62rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--c-ink);
}

/* Thin rule between label rows */
.wfe__stamp-row + .wfe__stamp-row {
  padding-top: 0.2rem;
  border-top: 1px solid rgba(168, 102, 66, 0.2);
}

/* Big coordinate display */
.wfe__stamp-coords {
  font-family: var(--font-display);
  font-size: clamp(0.95rem, 1.8vw, 1.35rem);
  color: var(--c-ink);
  line-height: 1.1;
  letter-spacing: 0.02em;
  margin: 0.4rem 0 0.6rem;
}

.wfe__stamp-divider {
  height: 1px;
  background: rgba(168, 102, 66, 0.3);
  margin-bottom: 0.5rem;
  /* Dashed effect */
  background: repeating-linear-gradient(to right, rgba(168, 102, 66, 0.4), rgba(168, 102, 66, 0.4) 8px, transparent 8px, transparent 14px);
}

.wfe__stamp-meta {
  display: flex;
  justify-content: space-between;
}

/* ── Word strip ─────────────────────────────────────────────── */
.wfe__strip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.75rem, 1vw, 1rem);

  margin-top: clamp(1.1rem, 1.1vw, 1rem);
}

.wfe__strip-item {
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.26em;
  text-transform: uppercase;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 2vw, 1.75rem);
}

.wfe__strip-dot {
  color: var(--accent);
  font-size: 0.5rem;
  line-height: 1;
}

/* ── Mountain divider (reuses wws pattern) ──────────────────── */
.wfe__divider {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  padding-inline: var(--gutter);
}

.wfe__divider-img {
  max-width: 700px;
  max-height: 18dvh;
  height: 100%;
  display: block;
  flex-shrink: 0;
}

/* ── Responsive ─────────────────────────────────────────────── */
@media (max-width: 768px) {
  .wfe__layout {
    grid-template-columns: 1fr;
    grid-template-areas:
      "left"
      "right";
    min-height: auto;
  }

  .wfe__rail {
    display: none;
  }

  .wfe__right {
    margin-right: calc(-1 * var(--gutter));
    margin-left: calc(-1 * var(--gutter));
    height: 60vw;
    min-height: 320px;
  }

  .wfe__photo {
    height: 100%;
  }

  .wfe__stamp-wrap {
    bottom: -1rem;
    right: -1rem;
  }

  .wfe__strip {
    flex-wrap: wrap;
    gap: 0.5rem 1.25rem;
  }

  .wfe__photo-wrap {
    width: 89%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    position: relative;
  }

  .wfe__photo {
    width: 100%;
    height: 100%;
    border-radius: 0.5rem 0.5rem 0 0;
    object-fit: cover;
    object-position: center 60%;
  }
}

@media (max-width: 575.98px) {
  .wfe__hl-ink,
  .wfe__hl-rust {
    font-size: clamp(1.7rem, 8vw, 2.4rem);
  }
  .wfe__stamp-wrap {
    bottom: -4rem;
    right: -4rem;
  }

  .wfe__stamp {
    width: 300px;
    scale: 0.5;
  }
  .wws__badge {
    width: 118.2px !important;
    height: 118.2px !important;
  }
}

/* ── Enhanced scroll animations (added Section 04 pass) ─────── */

/* Photo: subtle scale-in as it enters viewport */
.wfe__photo {
  transform-origin: center center;
  transition:
    transform 1.2s var(--ease),
    filter 0.8s var(--ease);
}

/* Stamp: slight slide-up in addition to framer-motion fadeUp */
.wfe__stamp-wrap {
  transition: transform 0.8s var(--ease);
}

/* Word strip: letters breathe in */
.wfe__strip-item {
  transition:
    color 0.4s var(--ease),
    letter-spacing 0.6s var(--ease);
}
.wfe__strip-item:hover {
  color: var(--accent);
  letter-spacing: 0.32em;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/WhyForgeExists.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,2CAA2C;EAC3C,mCAAmC;EACnC,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;;EAEhB,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,mCAAmC;EACnC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,mCAAmC;EACnC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,UAAU;EACV,kCAAkC;EAClC,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,+DAA+D;EAC/D,qCAAqC;AACvC;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;EACxB;;4CAE0C;EAC1C,kBAAkB;EAClB,wDAAwD;EACxD,kBAAkB;;EAElB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoGC;;EAED;;4CAE0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;EACT,UAAU;EACV,yGAAyG;AAC3G;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,wIAAwI;AAC1I;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;;EAE9B,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE;IACE,0BAA0B;IAC1B;;aAES;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sCAAsC;IACtC,qCAAqC;IACrC,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA,kEAAkE;;AAElE,iDAAiD;AACjD;EACE,+BAA+B;EAC/B;;2BAEyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,sCAAsC;AACxC;;AAEA,mCAAmC;AACnC;EACE;;mCAEiC;AACnC;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":["/* ============================================================\n   WhyForgeExists — Section 03\n   Two-column: left content + right full-bleed photo\n   ============================================================ */\n\n.wfe {\n  background: var(--c-cream);\n  padding-top: var(--section-y);\n  padding-bottom: 0;\n  overflow: hidden;\n  position: relative;\n}\n\n/* ── Two-column layout ──────────────────────────────────────── */\n.wfe__layout {\n  display: grid;\n  /* left content | thin rail | right photo */\n  grid-template-columns: 3rem 1fr 1fr;\n  grid-template-areas: \"rail left right\";\n  align-items: stretch;\n  min-height: 70vh;\n\n  margin-inline: auto;\n  padding-inline: var(--gutter);\n  gap: clamp(1.5rem, 3vw, 3rem);\n}\n\n/* ── Left column ────────────────────────────────────────────── */\n.wfe__left {\n  grid-area: left;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: clamp(1.25rem, 2.5vw, 2rem);\n  padding-block: clamp(1rem, 3vw, 2.5rem);\n}\n\n/* Section label */\n.wfe__label {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n}\n\n.wfe__num {\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.wfe__rule {\n  display: block;\n  width: 1px;\n  height: 1.1rem;\n  background: var(--line);\n  flex-shrink: 0;\n}\n\n/* ── Two-tone headline ──────────────────────────────────────── */\n.wfe__headline {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15em;\n  margin: 0;\n}\n\n/* First block — dark forest/ink */\n.wfe__hl-ink {\n  font-size: clamp(2rem, 4vw, 3.4rem);\n  color: var(--c-forest);\n  line-height: 0.99;\n}\n\n/* Second block — rust accent */\n.wfe__hl-rust {\n  font-size: clamp(2rem, 4vw, 3.4rem);\n  color: var(--accent);\n  line-height: 0.99;\n}\n\n/* ── Body paragraphs ────────────────────────────────────────── */\n.wfe__body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-width: 36rem;\n}\n\n.wfe__body p {\n  font-family: var(--font-body);\n  font-size: clamp(0.88rem, 1.1vw, 1rem);\n  color: var(--c-ink);\n  line-height: 1.68;\n}\n\n/* ── Signature row ──────────────────────────────────────────── */\n.wfe__sig-row {\n  display: flex;\n  align-items: center;\n  gap: clamp(1rem, 2.5vw, 2rem);\n  margin-top: 0.5rem;\n}\n\n/* Script signature — Playfair italic simulates handwriting */\n.wfe__sig-script {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-size: clamp(1.8rem, 3vw, 2.6rem);\n  color: var(--c-ink);\n  line-height: 1;\n  display: block;\n  margin-bottom: 0.4rem;\n  letter-spacing: -0.01em;\n}\n\n.wfe__sig-name {\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--c-ink);\n  display: block;\n}\n\n/* ── Circular badge (shared pattern) ───────────────────────── */\n.wfe__badge {\n  position: relative;\n  width: clamp(80px, 9vw, 120px);\n  height: clamp(80px, 9vw, 120px);\n  flex-shrink: 0;\n}\n\n.wfe__badge-ring {\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n\n.wfe__badge-circle {\n  fill: none;\n  stroke: var(--accent);\n  stroke-width: 1;\n  opacity: 0.55;\n}\n\n.wfe__badge-text {\n  font-family: var(--font-body);\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.18em;\n  fill: var(--accent);\n  text-transform: uppercase;\n}\n\n.wfe__badge-tick {\n  stroke: var(--accent);\n  stroke-width: 1.5;\n  opacity: 0.7;\n}\n\n.wfe__badge-logo {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wfe__badge-logo img {\n  width: 36%;\n  height: auto;\n  object-fit: contain;\n}\n\n/* ── Icon rail ──────────────────────────────────────────────── */\n.wfe__rail {\n  grid-area: rail;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-block: clamp(2rem, 4vw, 4rem);\n  gap: 0;\n}\n\n.wfe__rail-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 1rem;\n  color: var(--c-ink);\n  opacity: 0.75;\n}\n\n/* Connector segment between icons */\n.wfe__rail-seg {\n  display: block;\n  width: 1px;\n  height: clamp(1.5rem, 3.5vw, 3rem);\n  background: rgba(27, 27, 27, 0.28);\n  margin-block: 0.5rem;\n}\n\n/* ── Right column — photo ───────────────────────────────────── */\n.wfe__right {\n  grid-area: right;\n  position: relative;\n  margin-right: calc(-1 * var(--gutter));\n}\n\n/* Clip container so the parallax translateY stays inside bounds */\n.wfe__photo-wrap {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.wfe__photo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  display: block;\n  /* Slight desaturate to match the dramatic B&W look in design */\n  filter: grayscale(30%) contrast(1.08);\n}\n\n/* ── Coordinate stamp ───────────────────────────────────────── */\n.wfe__stamp-wrap {\n  position: absolute;\n  bottom: clamp(1.5rem, 4vw, 3rem);\n  right: clamp(1rem, 3vw, 2.5rem);\n  z-index: 2;\n}\n\n.wfe__stamp {\n  background: #e8d9b8;\n  border: 2px solid rgba(168, 102, 66, 0.35);\n  padding: 0.9rem;\n  width: clamp(200px, 22vw, 300px);\n  /* Aged / slightly rotated feel */\n  transform: rotate(10deg);\n  box-shadow:\n    0 4px 18px rgba(27, 27, 27, 0.22),\n    inset 0 0 0 1px rgba(168, 102, 66, 0.12);\n  position: relative;\n  /* Perforated right edge — dots via repeating gradient */\n  border-right: none;\n\n  clip-path: polygon(\n    4% 0%,\n    8% 2%,\n    12% 0%,\n    16% 2%,\n    20% 0%,\n    24% 2%,\n    28% 0%,\n    32% 2%,\n    36% 0%,\n    40% 2%,\n    44% 0%,\n    48% 2%,\n    52% 0%,\n    56% 2%,\n    60% 0%,\n    64% 2%,\n    68% 0%,\n    72% 2%,\n    76% 0%,\n    80% 2%,\n    84% 0%,\n    88% 2%,\n    92% 0%,\n    96% 2%,\n    100% 4%,\n\n    98% 8%,\n    100% 12%,\n    98% 16%,\n    100% 20%,\n    98% 24%,\n    100% 28%,\n    98% 32%,\n    100% 36%,\n    98% 40%,\n    100% 44%,\n    98% 48%,\n    100% 52%,\n    98% 56%,\n    100% 60%,\n    98% 64%,\n    100% 68%,\n    98% 72%,\n    100% 76%,\n    98% 80%,\n    100% 84%,\n    98% 88%,\n    100% 92%,\n    98% 96%,\n    96% 100%,\n\n    92% 98%,\n    88% 100%,\n    84% 98%,\n    80% 100%,\n    76% 98%,\n    72% 100%,\n    68% 98%,\n    64% 100%,\n    60% 98%,\n    56% 100%,\n    52% 98%,\n    48% 100%,\n    44% 98%,\n    40% 100%,\n    36% 98%,\n    32% 100%,\n    28% 98%,\n    24% 100%,\n    20% 98%,\n    16% 100%,\n    12% 98%,\n    8% 100%,\n    4% 98%,\n    0% 96%,\n\n    2% 92%,\n    0% 88%,\n    2% 84%,\n    0% 80%,\n    2% 76%,\n    0% 72%,\n    2% 68%,\n    0% 64%,\n    2% 60%,\n    0% 56%,\n    2% 52%,\n    0% 48%,\n    2% 44%,\n    0% 40%,\n    2% 36%,\n    0% 32%,\n    2% 28%,\n    0% 24%,\n    2% 20%,\n    0% 16%,\n    2% 12%,\n    0% 8%,\n    2% 4%\n  );\n\n  box-shadow:\n    0 4px 18px rgba(27, 27, 27, 0.22),\n    inset 0 0 0 1px rgba(168, 102, 66, 0.12);\n}\n\n.stamp_inner {\n  border: 2px solid var(--c-ink);\n  padding: 0.8rem;\n}\n\n/* Perforated edge simulation */\n.wfe__stamp::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: -1px;\n  bottom: 0;\n  width: 1px;\n  background: repeating-linear-gradient(to bottom, transparent, transparent 6px, #e8d9b8 6px, #e8d9b8 10px);\n}\n\n.wfe__stamp-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.55rem;\n}\n\n.wfe__stamp-name {\n  font-family: var(--font-display);\n  font-size: clamp(1.4rem, 2.5vw, 2rem);\n  color: var(--c-ink);\n  letter-spacing: 0.06em;\n  line-height: 1;\n}\n\n.wfe__stamp-logo {\n  width: clamp(18px, 2vw, 26px);\n  height: auto;\n  opacity: 0.85;\n}\n\n.wfe__stamp-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 0.15rem;\n}\n\n.wfe__stamp-label {\n  font-family: var(--font-body);\n  font-size: 0.58rem;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.wfe__stamp-value {\n  font-family: var(--font-body);\n  font-size: 0.62rem;\n  font-weight: 500;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--c-ink);\n}\n\n/* Thin rule between label rows */\n.wfe__stamp-row + .wfe__stamp-row {\n  padding-top: 0.2rem;\n  border-top: 1px solid rgba(168, 102, 66, 0.2);\n}\n\n/* Big coordinate display */\n.wfe__stamp-coords {\n  font-family: var(--font-display);\n  font-size: clamp(0.95rem, 1.8vw, 1.35rem);\n  color: var(--c-ink);\n  line-height: 1.1;\n  letter-spacing: 0.02em;\n  margin: 0.4rem 0 0.6rem;\n}\n\n.wfe__stamp-divider {\n  height: 1px;\n  background: rgba(168, 102, 66, 0.3);\n  margin-bottom: 0.5rem;\n  /* Dashed effect */\n  background: repeating-linear-gradient(to right, rgba(168, 102, 66, 0.4), rgba(168, 102, 66, 0.4) 8px, transparent 8px, transparent 14px);\n}\n\n.wfe__stamp-meta {\n  display: flex;\n  justify-content: space-between;\n}\n\n/* ── Word strip ─────────────────────────────────────────────── */\n.wfe__strip {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(0.75rem, 1vw, 1rem);\n\n  margin-top: clamp(1.1rem, 1.1vw, 1rem);\n}\n\n.wfe__strip-item {\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.26em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  gap: clamp(0.75rem, 2vw, 1.75rem);\n}\n\n.wfe__strip-dot {\n  color: var(--accent);\n  font-size: 0.5rem;\n  line-height: 1;\n}\n\n/* ── Mountain divider (reuses wws pattern) ──────────────────── */\n.wfe__divider {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.75rem;\n  padding-inline: var(--gutter);\n}\n\n.wfe__divider-img {\n  max-width: 700px;\n  max-height: 18dvh;\n  height: 100%;\n  display: block;\n  flex-shrink: 0;\n}\n\n/* ── Responsive ─────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .wfe__layout {\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      \"left\"\n      \"right\";\n    min-height: auto;\n  }\n\n  .wfe__rail {\n    display: none;\n  }\n\n  .wfe__right {\n    margin-right: calc(-1 * var(--gutter));\n    margin-left: calc(-1 * var(--gutter));\n    height: 60vw;\n    min-height: 320px;\n  }\n\n  .wfe__photo {\n    height: 100%;\n  }\n\n  .wfe__stamp-wrap {\n    bottom: -1rem;\n    right: -1rem;\n  }\n\n  .wfe__strip {\n    flex-wrap: wrap;\n    gap: 0.5rem 1.25rem;\n  }\n\n  .wfe__photo-wrap {\n    width: 89%;\n    height: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: hidden;\n    position: relative;\n  }\n\n  .wfe__photo {\n    width: 100%;\n    height: 100%;\n    border-radius: 0.5rem 0.5rem 0 0;\n    object-fit: cover;\n    object-position: center 60%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .wfe__hl-ink,\n  .wfe__hl-rust {\n    font-size: clamp(1.7rem, 8vw, 2.4rem);\n  }\n  .wfe__stamp-wrap {\n    bottom: -4rem;\n    right: -4rem;\n  }\n\n  .wfe__stamp {\n    width: 300px;\n    scale: 0.5;\n  }\n  .wws__badge {\n    width: 118.2px !important;\n    height: 118.2px !important;\n  }\n}\n\n/* ── Enhanced scroll animations (added Section 04 pass) ─────── */\n\n/* Photo: subtle scale-in as it enters viewport */\n.wfe__photo {\n  transform-origin: center center;\n  transition:\n    transform 1.2s var(--ease),\n    filter 0.8s var(--ease);\n}\n\n/* Stamp: slight slide-up in addition to framer-motion fadeUp */\n.wfe__stamp-wrap {\n  transition: transform 0.8s var(--ease);\n}\n\n/* Word strip: letters breathe in */\n.wfe__strip-item {\n  transition:\n    color 0.4s var(--ease),\n    letter-spacing 0.6s var(--ease);\n}\n.wfe__strip-item:hover {\n  color: var(--accent);\n  letter-spacing: 0.32em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
